import { useAxios, getQueryKey } from '@flex-packages/remote-hooks';
import { useQuery } from '@tanstack/react-query';
import chunk from 'lodash/chunk';
import '../../apis/search/apis/advanced-filter-controller-api.mjs';
import '../../apis/search/apis/department-search-action-controller-api.mjs';
import '../../apis/search/apis/search-license-action-controller-api.mjs';
import '../../apis/search/apis/search-user-template-api-controller-api.mjs';
import '../../apis/search/apis/user-search-action-controller-api.mjs';
import { timeSeriesSearchUserByIdsRemote } from '../../apis/search/apis/user-search-controller-api.mjs';

const SEARCH_USER_ID_HASHES_MAX_COUNT = 20;
function useSearchUserByIdsRemoteParams(extraParams) {
  const { customerIdHash, userIdHashes } = extraParams;
  const {
    instances: { json }
  } = useAxios();
  const [searchUserByIds, defaultConfig, extraConfigGenerator] = timeSeriesSearchUserByIdsRemote(json);
  const queryKey = getQueryKey({
    ...defaultConfig,
    ...extraConfigGenerator?.(extraParams)
  });
  async function queryFn() {
    const chunks = chunk(userIdHashes, SEARCH_USER_ID_HASHES_MAX_COUNT);
    const promises = chunks.map((userIdHashChunk) => {
      return searchUserByIds({
        customerIdHash,
        userIdHashes: userIdHashChunk
      });
    });
    const responses = await Promise.all(promises);
    return responses.map(({ data }) => data).flat();
  }
  return {
    queryKey,
    queryFn
  };
}
function useSearchUserByIdsRemote(extraParams, options) {
  const { queryKey, queryFn } = useSearchUserByIdsRemoteParams(extraParams);
  return useQuery({
    ...options,
    queryFn,
    queryKey
  });
}

export { useSearchUserByIdsRemote as default, useSearchUserByIdsRemoteParams };
//# sourceMappingURL=useSearchUserByIdsRemote.mjs.map
